import { clickOn } from "../../events/click";
import { load } from "../../events/load";

const initServicesListLoadMore = () => {
    const section = document.querySelector(".services-list");
    if (!section) return;

    const loadMoreBtn = section.querySelector("[data-services-load-more]");
    if (!loadMoreBtn) return;

    clickOn("[data-services-load-more]", (event, trigger) => {
        event.preventDefault();

        const hiddenItems = section.querySelector(".services-list__hidden-items");
        if (!hiddenItems) return;

        const isExpanded = section.classList.contains("is-expanded");
        const btnText = trigger.querySelector(".btn__text");

        if (!isExpanded) {
            // Expanding: Set fixed height for CSS transition from 0
            const height = hiddenItems.scrollHeight;
            hiddenItems.style.maxHeight = height + "px";
            section.classList.add("is-expanded");

            // Change text slightly later
            setTimeout(() => {
                if (btnText) btnText.textContent = trigger.dataset.textCollapse;
            }, 200);
        } else {
            // Collapsing: Set 0 for transition
            hiddenItems.style.maxHeight = "0px";
            section.classList.remove("is-expanded");

            // Change text slightly later
            setTimeout(() => {
                if (btnText) btnText.textContent = trigger.dataset.textExpand;
            }, 200);
        }
    });
};

load(initServicesListLoadMore);

